module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (!_vm.field.conditional || (_vm.field.conditional && _vm.conditionalTrue)) ? _c('div', {
    class: [
      'form__fieldset',
      {
        'fieldset--is-dirty': _vm.valid.$dirty || _vm.value,
        'fieldset--is-dirty-select': !_vm.isPlaceholder,
        'fieldset--is-focus': _vm.focus && !_vm.isReadonly,
        'fieldset--has-errors': _vm.valid.$error || _vm.serverError,
        'fieldset--is-conditional': _vm.conditionalTrue,
        'fieldset--is-hidden': _vm.field.hidden,
        'form__fieldset--is-readonly': _vm.isReadonly,
        'form__fieldset--conditional': _vm.field.conditional,
      }
    ],
    attrs: {
      "data-form-fieldset": _vm.fieldId
    }
  }, [_c('div', {
    class: [
      "form__label-wrapper",
      {
        'form__label-wrapper--hidden': _vm.field.labelHidden,
      } ]
  }, [(!_vm.field.labelHidden) ? _c(_vm.labelTag, {
    tag: "component",
    class: [
      "form__label",
      {
        'form__label--is-placeholder': _vm.isPlaceholder,
        'form__label--hidden': _vm.field.noLabel || _vm.fieldType === "boolean",
      } ],
    attrs: {
      "for": _vm.fieldId
    }
  }, [_vm._v("\n      " + _vm._s(_vm.field.label) + "\n      "), (_vm.fieldType === "file") ? _c('span', [_vm._v(_vm._s(("(" + (_vm.required ? "Required" : "Optional") + ")")))]) : _vm._e()]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    class: [
      'form__field',
      ("form__field--" + _vm.fieldType),
      {
        'form__field--toggle': _vm.isType("toggle"),
      }
    ],
    on: {
      "click": function($event) {
        _vm.focusField($event)
      }
    }
  }, [(!_vm.isType("toggle")) ? _c('b', {
    class: [
      'form__field-bg',
      {
        'form__field-bg--is-focus': _vm.focus && !_vm.isReadonly,
        'form__field-bg--has-errors': _vm.valid.$error || _vm.serverError,
        'form__field-bg--is-readonly': _vm.isReadonly,
      }
    ]
  }) : _vm._e(), _vm._v(" "), (_vm.isType("select")) ? _c('module-icon', {
    staticClass: "form__select-arrow",
    attrs: {
      "icon": "dropdown"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.field.icon) ? _c('b', {
    class: [
      "form__icon",
      ("form__icon--" + (_vm.field.icon)) ]
  }, [_c('module-icon', {
    attrs: {
      "icon": _vm.field.icon
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.field.prefix) ? _c('span', {
    class: "form__prefix",
    domProps: {
      "innerHTML": _vm._s(_vm.field.prefix)
    }
  }) : _vm._e(), _vm._v(" "), _c('module-form-field', {
    ref: "field",
    class: [
      'form__input',
      'form__input--' + _vm.fieldType,
      {
        'form__input--toggle': _vm.isType("toggle"),
        'form__input--prefix': _vm.field.prefix,
        'form__input--readonly': _vm.isReadonly,
      }
    ],
    attrs: {
      "id": _vm.fieldId,
      "field": _vm.field,
      "form-id": _vm.formId,
      "min": _vm.numberMin,
      "max": _vm.numberMax,
      "step": _vm.numberStep,
      "readonly": _vm.isReadonly,
      "toggle": _vm.toggle
    },
    on: {
      "focusBlur": _vm.onFocusBlur,
      "change": _vm.onChange,
      "fieldTouch": _vm.onFieldTouch
    },
    nativeOn: {
      "keydown": function($event) {
        _vm.onKeydown($event)
      }
    }
  }), _vm._v(" "), (_vm.isType('textarea') && _vm.field.counter) ? _c('span', {
    class: [
      "small",
      "form__counter" ]
  }, [_vm._v("\n      " + _vm._s((_vm.value || '').length) + _vm._s((_vm.field.validations || {}).maxLength ? '/' + (_vm.field.validations || {}).maxLength : '') + "\n    ")]) : _vm._e(), _vm._v(" "), (_vm.isType("file")) ? _c('module-button', {
    attrs: {
      "type": "button",
      "button": _vm.button
    }
  }, [(_vm.previewEncoded.length) ? _c('span', [_vm._v("Remove File")]) : _c('span', [_vm._v("Choose File")])]) : _vm._e(), _vm._v(" "), (_vm.isType("file")) ? _c('span', {
    class: "form__input form__input--faux form__input--file-faux"
  }, [(!_vm.previewEncoded.length) ? [_c('module-icon', {
    attrs: {
      "icon": "circle-plus"
    }
  })] : (_vm.previewEncoded.length === 1 && _vm.previewEncoded[0].name) ? [_vm._v("\n        " + _vm._s(_vm.previewEncoded[0].name) + "\n        ")] : [_vm._v(_vm._s(_vm.previewEncoded.length) + " files selected")]], 2) : _vm._e(), _vm._v(" "), (_vm.isType('color')) ? _c('span', {
    class: "p form__input form__input--faux"
  }, [_c('b', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_c('b', {
    style: ({
      backgroundColor: _vm.value
    })
  })]), _c('span', [_vm._v(_vm._s(_vm.value))])]) : _vm._e(), _vm._v(" "), (_vm.field.type === "password") ? _c('module-icon', {
    class: [
      "form__toggle-password",
      {
        'form__toggle-password--visible': _vm.toggle,
      } ],
    attrs: {
      "icon": !_vm.toggle ? "eye-crossed" : "eye",
      "title": ((_vm.toggle ? "Hide" : "Reveal") + " password"),
      "data-password-toggle": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.toggle = !_vm.toggle
      }
    }
  }) : _vm._e()], 1), _vm._v(" "), (_vm.isType("file")) ? _c('div', {
    staticClass: "form-preview"
  }, _vm._l((_vm.previewImages), function(image, index) {
    return _c('div', {
      key: index,
      class: "form-preview__item"
    }, [_c('span', {
      class: "form-preview__image",
      style: ({
        backgroundImage: ("url(" + (image.thumbnail || image.image) + ")"),
      })
    }), _vm._v(" "), (_vm.field.remove && image.id) ? _c('span', {
      class: "form-preview__remove",
      on: {
        "click": function($event) {
          _vm.$store.dispatch(_vm.field.remove, image.id)
        }
      }
    }, [_c('span', {
      staticClass: "visuallyhidden"
    }, [_vm._v("Delete image")]), _vm._v(" "), _c('module-icon', {
      attrs: {
        "icon": "cross"
      }
    })], 1) : _vm._e()])
  })) : _vm._e(), _vm._v(" "), (_vm.field.forgot && !_vm.isAuthenticated) ? _c('div', {
    staticClass: "form__forgot small"
  }, [_c('module-link', {
    attrs: {
      "label": "Forgotten Password?",
      "link": "authReset",
      "tabindex": "-1"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.field.helper && !_vm.valid.$error) ? _c('div', {
    staticClass: "form__helper small mb0 mt0"
  }, [(_vm.fieldValidations.max && _vm.fieldValidations.min) ? [_vm._v(_vm._s(((_vm.fieldValidations.min) + "–" + (_vm.fieldValidations.max) + " " + (_vm.isType("file") ? "file" : "character") + "(s)")))] : (_vm.fieldValidations.max) ? [_vm._v(_vm._s(((_vm.field.label) + " can contain " + (_vm.fieldValidations.max) + " " + (_vm.isType("file") ? "file" : "character") + "(s)")) + " "), _c('abbr', {
    attrs: {
      "title": "maximum"
    }
  }, [_vm._v("max.")])] : (_vm.fieldValidations.min) ? [_vm._v(_vm._s(((_vm.field.label) + " must contain at least " + (_vm.fieldValidations.min) + " " + (_vm.isType("file") ? "file" : "character") + "(s)")))] : _vm._e()], 2) : _vm._e(), _vm._v(" "), _c('module-form-errors', {
    attrs: {
      "server-error": _vm.serverError,
      "errors": _vm.valid,
      "label": _vm.field.errorLabel || _vm.field.label,
      "messages": _vm.field.errorMessages
    }
  })], 1) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-117b9cb2"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./client/components/modules/form/Fieldset.vue
// module id = 104
// module chunks = 3